import { AttitudesEnum } from 'helpers/types/Skills';

export type RGB = [ number, number, number ];
type Font = [ string, string ];
interface LegendSegment {
    color: RGB,
    text: string
};

export const PALETTE: Record<string, RGB> = {
  FONT_MAIN: [0, 0, 0],
  FONT_EXTRA: [114, 121, 129],
  FONT_REVERSE: [255, 255, 255],
  FONT_EXPERTISE_LEVEL: [35, 53, 74],
  FONT_ENGLISH_LEVEL: [51, 51, 51],
  
  HEADER_BACKGROUND: [0, 0, 0],
  HEADER_UNDERLINE: [244, 83, 110],

  SUBHEADER_BACKGROUND: [242, 244, 246],
  SUBHEADER_DIVIDER: [209, 219, 227],

  TAG_BACKGROUND: [238, 238, 238],
  TAG_LIKES_VERY_MUCH_BORDER: [96, 191, 122],
  TAG_LIKES_BORDER: [67, 129, 252],
  TAG_OK_TO_USE_BORDER: [255, 194, 52],
  TAG_DISLIKES_BORDER: [51, 51, 51],
  TAG_HATES_BORDER: [255, 31, 68],
  TAG_NOT_SPECIFIED_BORDER: [238, 238, 238],

  ENGLISH_LEVEL_EMPTY_CELL: [198, 198, 198],
  ENGLISH_LEVEL_FULFILLED_CELL: [67, 129, 252],
};

export const FONTS: Record<string, Font> = {
    HEADER: ["Helvetica", "bold"],
    SUBHEADER: ["Helvetica", "normal"],
};

export const LEGEND: LegendSegment[] = [
    {color: PALETTE.TAG_LIKES_VERY_MUCH_BORDER, text: "Likes very much"},
    {color: PALETTE.TAG_LIKES_BORDER, text: "Likes"},
    {color: PALETTE.TAG_OK_TO_USE_BORDER, text: "OK to use"},
    {color: PALETTE.TAG_DISLIKES_BORDER, text: "Dislikes"},
    {color: PALETTE.TAG_HATES_BORDER, text: "Hates"},
    {color: PALETTE.TAG_NOT_SPECIFIED_BORDER, text: "Not specified"},
];

export const CONTACTS: Record<string, string> = {
    emailAddress: "Email",
    phone: "Phone",
    location: "Location"
}

export const LINE_WIDTH = 0.25;

export const ATTITUDE_COLORS: Record<AttitudesEnum, RGB> = {
    [AttitudesEnum.Like]: PALETTE.TAG_LIKES_BORDER,
    [AttitudesEnum.Dislike]: PALETTE.TAG_DISLIKES_BORDER,
    [AttitudesEnum.Hate]: PALETTE.TAG_HATES_BORDER,
    [AttitudesEnum.Ok]: PALETTE.TAG_OK_TO_USE_BORDER,
    [AttitudesEnum.Super]: PALETTE.TAG_LIKES_VERY_MUCH_BORDER,
};
